import { useCurrentApp } from '@/stores/userDataStore';
import { generateReplaceBackgroundPrompt } from '@/utils/replaceImageBackground';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';

export const useReplaceBackgroundPrompt = ({
  productId,
  productTitle,
  productDescription,
  disablePromptQuery = false,
}: {
  productId?: string;
  productTitle?: string;
  productDescription?: string;
  disablePromptQuery?: boolean;
}) => {
  const [prompt, setPrompt] = useState('');
  const { isLoggedIn, isLoading: isLoadingUser } = useCurrentApp();
  const promptQuery = useQuery({
    enabled: !!productId && !disablePromptQuery && isLoggedIn,
    queryKey: ['replace-background-prompt', productId],
    staleTime: Infinity,
    queryFn: async () => generateReplaceBackgroundPrompt(productTitle, productDescription),
  });

  useEffect(() => {
    if (promptQuery.data) {
      setPrompt(promptQuery.data.prompt);
    }
  }, [promptQuery.data, setPrompt]);

  return useMemo(
    () => ({ prompt, setPrompt, isLoading: isLoadingUser || promptQuery.isLoading }),
    [prompt, setPrompt, promptQuery.isLoading, isLoadingUser]
  );
};
